<div
  class="container-fluid justify-content-center mb-0 pt-2 pb-0 shadow-lg col-12"
>
  <div class="jumbotron-fluid mx-0 px-0 mt-1 pt-2 mb-0 pb-0">
    <div class="container my-1 mx-0 shadow-lg">
      <div class="row">
        <div class="col-12">
          <h3 class="rub-head4 text-info text-center font-weight-bold py-1">
            Loans
          </h3>
        </div>
      </div>
    </div>
    <div class="container mx-auto px-0 mb-0 pb-0">
      <div class="d-flex justify-content-start my-0 pt-2 pb-0 mx-0 px-0">
        <div class="col-12 mx-0 px-1">
          <a routerLink="setloanlimit" class="text-info"
            ><button
              class="btn btn-info mb-1 ml-1 mr-0 px-auto px-lg-3"
              tooltip="Set Loan Rate"
            >
              Set Limit
            </button>
          </a>
          <a routerLink="setloanrate" class="text-info">
            <button
              class="btn btn-info mb-1 ml-1 mr-0 px-auto px-lg-3"
              tooltip="Set Interest Rate"
            >
              Set Rate
            </button>
          </a>
          <a routerLink="setloantenure" class="text-info"
            ><button
              class="btn btn-info mb-1 ml-1 mr-0 px-auto px-lg-3"
              tooltip="Set Loan Rate"
            >
              Set Tenure
            </button>
          </a>
          <a routerLink="setloancommission" class="text-info"
            ><button class="btn btn-info mb-1 ml-1 mr-0 px-auto px-lg-1">
              Set Commission Rate
            </button>
          </a>
          <a routerLink="setloanaccrual" class="text-info"
            ><button class="btn btn-info mb-1 ml-1 mr-0 px-auto px-lg-2">
              Set Accrual Days
            </button>
          </a>
          <a
            routerLink="loanamortizecycle"
            class="text-info"
            tooltip="Loan Amortization cycle"
            ><button class="btn btn-info mb-1 ml-1 mr-0 px-auto px-lg-2">
              Amort'n cycle
            </button>
          </a>
          <a
            routerLink="loanamortizetype"
            class="text-info"
            tooltip="Loan Amortization type"
            ><button class="btn btn-info mb-1 ml-1 mr-0 px-auto px-lg-2">
              Amort'n type
            </button>
          </a>
        </div>
        <!-- <div class="col-2 col-md-1 mx-0 px-0">
          <div ngbDropdown class="d-inline-block mx-0 px-0">
            <button
              class="btn btn-info mx-0 px-2"
              id="dropdownBasic1" tooltip="Loan Settings"
              ngbDropdownToggle
            >
              <i class="fas fa-eye"></i> View
            </button>
            <div
              ngbDropdownMenu
              aria-labelledby="dropdownBasic1"
              class="dropdown-menu"
            >
              <button ngbDropdownItem>Loan Limit</button>
              <button ngbDropdownItem>Loan Rate</button>
              <button ngbDropdownItem>Loan Tenure</button>
              <button ngbDropdownItem>Set Commission Rate</button>
              <button ngbDropdownItem>Set Accrual Days</button>
            </div>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</div>
<router-outlet></router-outlet>
